/**
 * JS API
 */

class datafeeds {

	/**
	 * JS API
	 * @param {*Object} vue vue实例
	 */
	constructor(vue) {
		this.self = vue
		//this.barsUpdater = new dataUpdater(this)
	}

	/**
	 * @param {*Function} callback  回调函数
	 * `onReady` should return result asynchronously.
	 */
	onReady(callback) {
		return new Promise((resolve, reject) => {
			let configuration = this.defaultConfiguration()
			if (this.self.getConfig) {
				configuration = Object.assign(this.defaultConfiguration(), this.self.getConfig())
			}
			resolve(configuration)
		}).then(data => callback(data))
	}

	/**
	 * 搜索商品
	 * @param {*String} userInput  用户在商品搜索框中输入的文字。
	 * @param {*String} exchange 请求的交易所（由用户选择）。空值表示没有指定
	 * @param {*String} symbolType  请求的商品类型：指数、股票、外汇等等（由用户选择）。空值表示没有指定。
	 * @param {*Function} onResultReadyCallback 提供一个匹配用户搜索的商品列表
	 */
	searchSymbols(userInput, exchange, symbolType, onResultReadyCallback) {

	}

	/**
	 * @param {*String} symbolName  商品名称或ticker
	 * @param {*Function} onSymbolResolvedCallback 成功回调 
	 * @param {*Function} onResolveErrorCallback   失败回调
	 * @param {*} extension 
	 * `resolveSymbol` should return result asynchronously.
	 */
	resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback, extension) {
		// console.log('[resolveSymbol]: Method call', symbolName);
		return new Promise((resolve, reject) => {
			let symbolInfo = this.defaultSymbol()
			if (this.self.getSymbol) {
				symbolInfo = Object.assign(this.defaultSymbol(), this.self.getSymbol())
			}
			resolve(symbolInfo)
		}).then(data => onSymbolResolvedCallback(data)).catch(err => onResolveErrorCallback(err))
	}

	/**
	 * 这个接口专门用于获取历史数据，即当前时刻之前的数据
	 * @param {*} symbolInfo 商品信息对象,这里面其实是上面定义的产品设置的时候回调用的方法
	 * @param {*} resolution 直译过来叫“分辨率”，这里指 K 线图中相邻两条柱子之间的时间间隔
	 * @param {*} periodParams 具有以下字段:
					from - unix 时间戳, 最左边请求的K线时间(K线时间 >= from)
					countBack - 要加载的K线的确切数量，如果您的datafeed支持它（见下文），则将视为拥有比 from 更高的优先级。 如果用户请求特定时间段，则可以不指定。
					to: unix 时间戳, 最右边请求的K线时间(K线时间 < to)
					firstDataRequest: 布尔值，以标识是否第一次调用此商品/周期的历史记录。当设置为true时 你可以忽略to参数（这取决于浏览器的Date.now()) 并返回K线数组直到最新K线。
	 * @param {*} onHistoryCallback function(数组bars,meta={ noData = false }) 历史数据的回调函数。每次请求只应被调用一次。 此函数有2个参数：
					bars: Bar对象数组{time, close, open, high, low, volume}[]
					meta: object{noData = true | false, nextTime = unix time}
	 * @param {*} onErrorCallback 
	 * @returns 
	 */
	getBars(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
		const onLoadedCallback = data => {
			data && data.length ? onHistoryCallback(data, {
				noData: false
			}) : onHistoryCallback([], {
				noData: true
			})
		}
		this.self.getBars(symbolInfo, resolution, periodParams, onLoadedCallback)
	}

	/**
	 * 订阅K线数据。图表库将调用onRealtimeCallback方法以更新实时数据
	 * @param {*Object} symbolInfo 商品信息
	 * @param {*String} resolution 分辨率
	 * @param {*Function} onRealtimeCallback 回调函数 
	 * @param {*String} subscriberUID 监听的唯一标识符
	 * @param {*Function} onResetCacheNeededCallback (从1.7开始): 将在bars数据发生变化时执行,调用次回调让图表再次请求历史K线数据
	 */
	subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) {
		//this.barsUpdater.subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback)
		this.self.subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback)
	}

	/**
	 * 取消订阅K线数据
	 * @param {*String} subscriberUID 监听的唯一标识符
	 */
	unsubscribeBars(subscriberUID) {
		this.self.unsubscribeFromStream(subscriberUID)
		//this.barsUpdater.unsubscribeBars(subscriberUID)
	}

	/**
	 * 默认配置
	 */
	defaultConfiguration() {
		return {
			supports_search: true,
			supports_group_request: false,
			supported_resolutions: ['1', '5', '15', '30', '60', '1D', '2D', '3D', '1W', '1M'],
			supports_marks: true,
			supports_timescale_marks: true,
			supports_time: true
		}
	}

	/**
	 * 默认商品信息
	 */
	defaultSymbol() {
		return {
			'ticker': 'HBbtcusdt',
			'name': 'BTCUSDT',
			'full_name': 'BTCUSDT',
			'timezone': 'Asia/Shanghai',
			'minmov': 1,
			'minmov2': 0,
			'pointvalue': 1,
			'fractional': false,
			'session': '24x7',
			'has_intraday': true,
			'has_no_volume': false,
			'description': 'BTCUSDT',
			'pricescale': 100000000,
			'intraday_multipliers': ['1', '5', '15', '30', '60', '1D'], // 自行构建的参数,允许TV自行构建
			'supported_resolutions': ['1', '5', '15', '30', '60', '1D']
		}
	}
}

export default datafeeds